export default "__VITE_ASSET__C2Jmjgnx__"